import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const HeartIcon = require("../../Assets/Images/Heart-Icon.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  container: {
    gap: "20px",
    width: "100%",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#426B88",
    textAlign: "left",
    lineHeight: "35px",
    height: "35px",
    marginBottom: "5px",
    fontFamily: "Lato",
  },
  row: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "15px",
    width: "100%",
  },
  icon: {
    width: "78px",
    height: "78px",
    alignSelf: "flex-start",
  },
  section: {
    width: "100%",
    height: "79px",
    borderRadius: "5px",
    padding: "10px",
    backgroundColor: "#EAF1F5",
  },
  highlight: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#00577D",
    textAlign: "left",
    lineHeight: "18px",
    fontFamily: "Lato",
  },
  text: {
    fontSize: "12px",
    lineHeight: "18px",
    color: "#00577D",
    fontWeight: "400",
    marginBottom: "0px",
  },
  textContainer: {
    flex: 1,
    justifyContent: "flex-start",
  },
  textPoints: {
    gap: "40px",
    height: "36px",
    color: "#00577D",
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    flexDirection: "row",
    justifyContent: "left",
    marginLeft: "10px",
  },
  StrengthSection: {
    width: "100%",
    height: "166px",
    borderRadius: "5px",
    padding: "10px",
    gap: "10px",
    backgroundColor: "#F1F8F1",
  },
  ChallengeSection: {
    width: "100%",
    height: "166px",
    borderRadius: "5px",
    padding: "10px",
    gap: "10px",
    backgroundColor: "#FFF0EC",
  },
});

const GroupHeartStarter = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>GROUP PROFILE: HEART STARTER</Text>

      {/* Image + Text in One Row */}
      <View style={styles.row}>
        <Image src={HeartIcon} style={styles.icon} />
        <View style={styles.textContainer}>
          <Text style={styles.text}>
            The group is characterized by a Heart Starter dynamic, thriving on
            deep connections and emotional engagement. As a Heart Starter Group,
            you are likely to prioritize relationships and are driven by a
            collective desire to belong. This often motivates the group to form
            deeper, more meaningful connections both within and outside the
            group.
          </Text>
        </View>
      </View>

      {/* Heart Starter Questions */}
      <View style={styles.section}>
        <Text style={styles.highlight}>Core questions guiding the group:</Text>
        <View style={styles.textPoints}>
          <View>
            <Text>• Who needs to be involved in this initiative?</Text>
            <Text>• Who fits our culture?</Text>
          </View>
          <View>
            <Text>• Who can we collaborate with?</Text>
            <Text>• Who benefits from our work?</Text>
          </View>
        </View>
      </View>

      {/* Strengths Section */}
      <View style={styles.StrengthSection}>
        <Text style={styles.highlight}>Strengths:</Text>
        <Text style={styles.text}>
          The Heart Starter Group excels in fostering a supportive and inclusive
          culture. They are skilled at rallying around common goals and engaging
          with each other on a level that transcends mere task execution. This
          focus on emotional connections enhances group cohesion and drives them
          to share experiences and insights generously, creating a strong
          communal spirit.
        </Text>
      </View>

      {/* Challenges Section */}
      <View style={styles.ChallengeSection}>
        <Text style={styles.highlight}>Challenges:</Text>
        <Text style={styles.text}>
          While the capacity for empathy and connection is a significant asset,
          it can sometimes lead to challenges. The group may become overly
          attached to consensus or emotional agreement, potentially at the
          expense of decisiveness or efficiency. A deep sense of empathy can
          also lead the group to take on more emotional burdens than is
          sustainable, which may affect overall productivity and focus. Overall,
          a Heart Starter Group is a powerful cultural force for creating a
          positive and connected work environment, ensuring that every member
          feels valued and heard.
        </Text>
      </View>
    </View>
  );
};

export default GroupHeartStarter;
